import React, { FC, ReactNode, useContext } from 'react';
import { Flexbox } from '@bankiru/ui-kit/components/Flexbox';
import { Indent } from '@bankiru/ui-kit/components/Indent';
import Text from '@bankiru/ui-kit/core/Text';

import { ThemeContext } from '../../../../../context/ThemeContextWrapper';
import { isMobilePlatform } from '../../../../../helpers/isMobilePlatform';
import { I18n } from '../../../../i18n';

export type CommonLoginProvidersProps = {
	phoneButton: ReactNode;
	consentsList: ReactNode;
	mainProvidersList: ReactNode;
	otherProvidersList: ReactNode;
	i18n: I18n;
};

export const LoginSelectLayoutCommon: FC<CommonLoginProvidersProps> = ({
	phoneButton,
	consentsList,
	mainProvidersList,
	otherProvidersList,
	i18n,
}) => {
	const { isMobile, isIOS, platform } = useContext(ThemeContext);

	const { msg } = i18n;

	return (
		<Flexbox flexDirection="column" margins={isMobile ? [16, 16] : [16, 16]}>
			<Indent margin={isMobile ? '16 0 0 0' : '24 0 0 0'}>
				<Flexbox flexDirection="column" gap={isMobile ? '4' : '8'}>
					<Text
						size={isMobile ? 'fs16' : 'fs20'}
						color="primary"
						align="center"
						weight="bold"
					>
						{msg('loginDescriptionTitle')}
					</Text>
					<Text size={isMobile ? 'fs14' : 'fs16'} color="secondary" align="center">
						{msg(
							isIOS || isMobilePlatform(platform)
								? 'loginDescriptionIOS'
								: 'loginDescription',
						)}
					</Text>
				</Flexbox>
			</Indent>
			<Flexbox flexDirection="column" gap="16">
				{mainProvidersList}
				<Flexbox flexDirection="column" gap="16">
					<Flexbox gap={8} alignItems="center">
						<Flexbox flexGrow="1" flexDirection="column">
							<hr className="hSeparator" />
						</Flexbox>
						<Text size="fs14" weight="medium" color="tertiary">
							{msg('anotherWays')}
						</Text>
						<Flexbox flexGrow="1" flexDirection="column">
							<hr className="hSeparator" />
						</Flexbox>
					</Flexbox>
					<Flexbox flexDirection="column" gap="8">
						{phoneButton}
						{otherProvidersList}
					</Flexbox>
				</Flexbox>
			</Flexbox>
			{consentsList}
		</Flexbox>
	);
};
